export default "__VITE_ASSET__C3yDt7Jd__"